






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChatMember } from '@/types/apiServerContract';

@Component
export default class GroupChatMember extends Vue {
	@Prop({ required: true }) member!: ChatMember;
}
